import { render, staticRenderFns } from "./LayoutCamara.vue?vue&type=template&id=1ff9af1a&scoped=true"
import script from "./LayoutCamara.vue?vue&type=script&lang=js"
export * from "./LayoutCamara.vue?vue&type=script&lang=js"
import style0 from "./LayoutCamara.vue?vue&type=style&index=0&id=1ff9af1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9af1a",
  null
  
)

export default component.exports